/**
 * Analytics utility for tracking events via Umami
 *
 * Events tracked for retention/funnel analysis:
 * - login: User logs in
 * - register: User creates account
 * - feed_subscribe: User subscribes to a feed
 * - article_read: User opens article reader
 * - article_share: User shares an article
 * - article_like: User likes an article
 * - comment_create: User posts a comment
 */

declare global {
  interface Window {
    umami?: {
      track: (eventName: string, eventData?: Record<string, string | number>) => void;
    };
  }
}

/**
 * Track an event in Umami analytics
 * @param eventName - Name of the event (e.g., 'login', 'feed_subscribe')
 * @param eventData - Optional data to include with the event
 */
export function trackEvent(eventName: string, eventData?: Record<string, string | number>): void {
  if (typeof window !== 'undefined' && window.umami) {
    window.umami.track(eventName, eventData);
  }
}
